module.exports = __webpack_public_path__ + "img/ks-hero-persaraan-anda.f01989e9.png";